const processEnv: {
  [key: string]: {
    remoteServiceBaseUrl: string;
    pushUrl?: string;
    secretKey?: string;
  };
} = {
  dev: {
    remoteServiceBaseUrl: 'https://test-h5.wondfo.com.cn:8084/gateway/eapsystemwhq',
    // remoteServiceBaseUrl: 'http://http://192.168.9.24:8801/eapsystem',
    secretKey: 'AppMobile',
  },
  test: {
    remoteServiceBaseUrl: 'https://test-h5.wondfo.com.cn:8084/gateway/eapsystem',
    secretKey: 'AppMobile',
  },
  prod: {
    remoteServiceBaseUrl: 'https://h5.wondfo.com.cn:8084/gateway/eapsystem',
    secretKey: 'AppMobile',
  },
};
const REACT_APP_ENV = process.env.REACT_APP_ENV || 'dev';
const AppConsts = {
  appid: 'wx536f2888253bb858',
  ...processEnv[REACT_APP_ENV],
};
console.log('AppConsts', AppConsts);
export default AppConsts;
